<template>
  <v-container fluid>
    <core-app-bar />
    <v-row>
      <v-col class="text-right">
        <v-btn
          class="mx-3"
          color="primary"
          to="/exportdetails"
          :disabled="!listLoaded"
        >
          <v-icon>mdi-database-plus-outline</v-icon>{{ $t('createExport') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <exports-list :fetch-method="fetchMethod" @loaded="onListLoaded" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExportsService from '@/services/ExportsService'
import ExportsList from '@/components/hmd/Exports/ExportsList'

export default {
  name: 'Exports',
  components: {
    CoreAppBar: () => import('@/components/layouts/core/AppBar'),
    ExportsList,
  },
  data: () => ({
    listLoaded: false,
  }),
  methods: {
    fetchMethod(page, itemsPerPage) {
      return ExportsService.listExports(this, page, itemsPerPage)
    },
    onListLoaded() {
      this.listLoaded = true
    },
  },
}
</script>
